import React from "react";
import ReactDOM from "react-dom/client";

import { createBrowserRouter } from "react-router";

import { AuthProvider } from "react-oidc-context";
import { RouterProvider } from "react-router";
import { ThemeProvider } from "@emotion/react";

import routes from "./routes";
import { GlobalStateProvider } from "./utils/GlobalStateContext";
import oidcAuth from "./oidc-config";

const oidcConfig = {
  authority: oidcAuth?.dev?.authority || "",
  client_id: oidcAuth?.dev?.client_id || "",
  redirect_uri: `${window.location.origin}`,
  scope: "openid profile api://3bae94c5-3f49-4b88-accc-d37a19d1c0f8/Test.group",
};
console.log(oidcConfig);
const theme = {};

const router = createBrowserRouter(routes);

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme} >
      <AuthProvider {...oidcConfig}>
        <GlobalStateProvider>
          <RouterProvider router={router} />
        </GlobalStateProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
